import { render, staticRenderFns } from "./SDGsForm.vue?vue&type=template&id=0dc8d1c9"
import script from "./SDGsForm.vue?vue&type=script&lang=js"
export * from "./SDGsForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports